const dateFormatReverse = (date = new Date('2020-12-16')) => {
    return date.split("-").reverse().join("-");
}

export { dateFormatReverse };
export default dateFormatReverse;